import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatOdds(odds) {
  return odds.toFixed(2);
}

export function formatDate(date) {
  const [day, month, year] = date.split("-");
  const dateObj = new Date(`${year}-${month}-${day}`);
  return dateObj.toLocaleDateString("en-AU", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function formatGoingCondition(going) {
  if (going === undefined || going === null) return "Unknown Going";

  // Handle numeric going conditions
  if (typeof going === "number") {
    const goingMap = {
      1: "Heavy 10",
      2: "Heavy 9",
      3: "Heavy 8",
      4: "Soft 7",
      5: "Soft 6",
      6: "Soft 5",
      7: "Good 4",
      8: "Good 3",
      9: "Firm 2",
      10: "Firm 1",
    };
    return goingMap[going] || `Going ${going}`;
  }

  // Handle string going conditions
  return going.charAt(0).toUpperCase() + going.slice(1).toLowerCase();
}

export function formatBetType(betType) {
  return betType
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function formatStake(stake) {
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(stake);
}
